import {react2panel} from 'common/util/react2panel';

import {MarkdownReact} from './index';

// Lazy initialization to avoid circular dependency with `panel` at module load time
let cachedMarkdownEl: ((props: any) => any) | null = null;
export const MarkdownEl = ((props: any) => {
  if (!cachedMarkdownEl) {
    cachedMarkdownEl = react2panel(`mp-markdown`, MarkdownReact);
  }
  return cachedMarkdownEl(props);
}) as ReturnType<typeof react2panel>;
